import { Input as InputPrimitive } from '@base-ui/react/input';
import { forwardRef, type InputHTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export type InputProps = InputHTMLAttributes<HTMLInputElement> & { invalid?: boolean };

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid = false, ...rest },
  ref,
) {
  return (
    <InputPrimitive
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        'bg-surface-raised text-fg placeholder:text-fg-subtle h-10 w-full min-w-0 rounded-md border px-3 text-sm transition-colors',
        'focus-visible:border-ring focus-visible:ring-ring/15 focus-visible:outline-none focus-visible:ring-2',
        invalid ? 'border-danger' : 'border-line-strong',
        className,
      )}
      {...rest}
    />
  );
});
